import { c as _c } from "react/compiler-runtime";
import { Cents } from '@systemeio/types';
import { centsToUnits } from '@systemeio/util';
import HeaderBlock from 'modules/profile/user-plan/components/price-plan-columns/components/header-block';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { tableFeatures, UserPlanInterface, UserResourcesInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { getFeatureLimitTitle, isPricePlanFeatureExceeded } from 'modules/profile/user-plan/utils/price-plan-utils';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
export interface ActiveUserPlanColumnProps {
  pricePlan: UserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  userRecourses: UserResourcesInterface;
}
const getResourceDisplayValue = (userRecourses: UserResourcesInterface, resourceKey: keyof UserResourcesInterface) => {
  if (resourceKey === 'totalRevenue' && userRecourses.totalRevenue !== null) {
    return centsToUnits(userRecourses.totalRevenue as Cents);
  }
  return userRecourses[resourceKey];
};
const ActiveUserPlanColumn = t0 => {
  const $ = _c(10);
  const {
    pricePlan,
    billingPeriod,
    userRecourses
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== billingPeriod || $[1] !== pricePlan) {
    t1 = <HeaderBlock pricePlan={pricePlan} billingPeriod={billingPeriod} active={true} />;
    $[0] = billingPeriod;
    $[1] = pricePlan;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== pricePlan || $[4] !== t || $[5] !== userRecourses) {
    t2 = tableFeatures.map((column, index) => <React.Fragment key={`active-column-${column.key}`}><div className={twMerge("text-text-primary truncate text-center text-base", isPricePlanFeatureExceeded(userRecourses, pricePlan, column) && "text-text-error")}>{(column.resourceKey ? `${getResourceDisplayValue(userRecourses, column.resourceKey)}/` : "").concat(getFeatureLimitTitle({
          pricePlan,
          key: column.key,
          t
        }))}</div>{tableFeatures[index + 1] ? <hr className="border-border-200 -mr-6 border-solid" /> : <div />}</React.Fragment>);
    $[3] = pricePlan;
    $[4] = t;
    $[5] = userRecourses;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="border-border-accent bg-bg-accent-light desktop:grid flex w-full min-w-full snap-start flex-col gap-2 rounded-sm border border-solid">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default ActiveUserPlanColumn;